//@flow
import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import serverVars from 'server-vars';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import { trackDesignerConnectionPostConfirmationModalReferer } from 'dibs-buyer-layout/exports/designerConnectionTracking';

import { MatchmakerContainer } from '../matchmaker/MatchmakerContainer';

import '../matchmaker/matchmaker.scss';

const locale = serverVars.get('localeDataKey');
const messages = serverVars.get('messages');

initializeDBL().then(() => {
    trackDesignerConnectionPostConfirmationModalReferer();

    const matchMakerNode = React.createElement(MatchmakerContainer);
    const containerElement = document.getElementById('matchmakerRoot');

    if (containerElement) {
        ReactDOM.render(
            React.createElement(IntlProvider, { locale, messages }, matchMakerNode),
            document.getElementById('matchmakerRoot')
        );
    }
});
